import script from "./LocationView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationView.vue?vue&type=script&setup=true&lang=js"

import "./LocationView.vue?vue&type=style&index=0&id=66bd18b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bd18b1"]])

export default __exports__